import { Component, OnDestroy } from '@angular/core';
import * as UserActions from '../../../../../store/user/actions';
import { select, Store } from '@ngrx/store';
import * as SettingsActions from '../../../../../store/settings/actions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as Reducers from '../../../../../store/reducers';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-system-lockscreen',
	templateUrl: './lockscreen.component.html',
	styleUrls: ['../style.component.scss']
})
export class LockscreenComponent implements OnDestroy {
	form: FormGroup;
	loading = false;
	email: string;
	name: string;

	private subscription = new Subscription();

	constructor(private fb: FormBuilder, private store: Store<any>) {
		this.form = fb.group({
			email: ['', [Validators.required, Validators.minLength(4)]],
			password: ['', [Validators.required]]
		});
		this.subscription.add(this.store.pipe(select(Reducers.getUser)).subscribe(state => {
			this.email = state.email;
			this.name = state.name || state.username;
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	get password() {
		return this.form.controls.password;
	}

	submitForm(): void {
		this.password.markAsDirty();
		this.password.updateValueAndValidity();
		const authProvider = 'jwt';
		this.store.dispatch(
			new SettingsActions.SetStateAction({
				authProvider
			})
		);
		const payload = {
			email: this.email,
			password: this.password.value
		};
		this.store.dispatch(new UserActions.Login(payload));
	}
}
